/// <amd-module name="typeahead/core/logging/TypeaheadErrorLogger"/>

import {DctkClientLogErrorTransport} from "typeahead/core/logging/DctkClientLogErrorTransport";
import {ErrorLogger} from "typeahead/core/logging/ErrorLogger";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";

const logger: ErrorLogger = new ErrorLogger(new DctkClientLogErrorTransport());

export default {
    log(error: Error, severity: Severity, origin: ProblemOrigin, additional: object = {}): void {
        logger.log(error, severity, origin, additional);
    },
};
